<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>业务信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="提示: 业务信息将会出现在您的主页上，丰富的内容有助于提高您的资质，便于更多企业快速阅览，促进交易"></el-alert>
		</div>
		<el-form label-width="150px" ref="form" :model="form" :disabled="preview" :rules="rules" size="small">
			<el-row>
				<el-col :span="12">
					<el-form-item label="主要身份" prop="zySf">
						<el-select v-model="form.zySf" style="width: 100%" placeholder="请选择主要身份">
							<el-option label="产品销售商" value="产品销售商"></el-option>
							<el-option label="外协加工商" value="外协加工商"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="经营性质" prop="jyXz">
						<el-select v-model="form.jyXz" style="width: 100%" placeholder="请选择经营性质">
							<el-option label="制造商" value="制造商"></el-option>
							<el-option label="贸易商" value="贸易商"></el-option>
							<el-option label="服务商" value="服务商"></el-option>
							<el-option label="代理商" value="代理商"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="行业类型" prop="hyType">
						<el-input v-model="form.hyType" placeholder="请输入行业类型" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="送货服务范围" prop="shFwScope">
						<el-select v-model="form.shFwScope" placeholder="请选择送货服务范围" style="width: 100%;">
							<el-option v-for="item in shFwScopes" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="公司官网" prop="gsGw">
						<el-input v-model="form.gsGw" placeholder="请输入公司官网" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="公司Logo" prop="gsLogoSrc">
						<el-upload class="upload-demo" :action="upload()" :show-file-list="false" accept="image/*,.pdf"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
							:headers="{'Authentication':token()}">
							<el-input v-model="form.gsLogoSrc" placeholder="点击文本框上传" readonly slot="trigger" />
						</el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="主营品类及业务范围" prop="zyClass">
						<el-input v-model="form.zyClass" type="textarea" :rows="4" placeholder="请输入主营品类" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="公司简介" prop="gsDetail">
						<el-input v-model="form.gsDetail" type="textarea" :rows="4" placeholder="请输入公司简介" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="submitForm(2)" size="small">下一步</el-button>
			</span>
		</div>
	</div>
</template>

<script>
	import {
		supplierInfoById,
		addSupplierInfo,
		editSupplierInfo,
		addSupplierApprovalMx,
		getSupplierApprovalMx
	} from '@/api/gys/supplierInfo.js'
	import constant from '@/api/commons.js'
	import { queryByParentId } from '@/api/basic/commodityClassification.js'
	export default {
		name: "YwInfo",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {

				title: "",
				tableData: [],
				shFwScopes: constant.shFwScopes,
				form: {
					id: undefined,
					zySf: undefined,
					jyXz: undefined,
					hyType: undefined,
					zyClass: undefined,
					shFwScope: undefined,
					gsGw: undefined,
					gsLogoSrc: undefined,
					gsDetail: undefined,
				},
				classData:[],
				loadingInstance: undefined,
				count: 0,
				fileName: '',
				rules: {
					zySf: [{
						required: true,
						message: '请输入主要身份',
						trigger: 'blur'
					}],
					jyXz: [{
						required: true,
						message: '请输入经营性质',
						trigger: 'blur'
					}],
					hyType: [{
						required: true,
						message: '请输入行业类型',
						trigger: 'blur'
					}],
					zyClass: [{
						required: true,
						message: '请输入主营品类',
						trigger: 'blur'
					}],
					shFwScope: [{
						required: true,
						message: '请输入送货服务范围',
						trigger: 'blur'
					}],
					// gsLogoSrc: [{
					// 	required: true,
					// 	message: '请输入公司Logo',
					// 	trigger: 'blur'
					// }],
					gsDetail: [{
						required: true,
						message: '请输入公司简介',
						trigger: 'blur'
					}]
				}
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			async getList() {
				let _this = this;
				let pramar = {
					classType:'com.srm.entity.SupplierInfo',
					classTypeIndex:'1',
					supplierInfoId:_this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				const { data: res } = await getSupplierApprovalMx(pramar)
				if (res.code == 0) {
					if(res.data && res.data.jsonData){
						let JsonInfo = JSON.parse(res.data.jsonData);
						_this.form = {
							id: undefined,
							zySf: JsonInfo.zySf||undefined,
							jyXz: JsonInfo.jyXz||undefined,
							hyType: JsonInfo.hyType||undefined,
							zyClass: JsonInfo.zyClass||undefined,
							shFwScope: JsonInfo.shFwScope||undefined,
							gsGw: JsonInfo.gsGw||undefined,
							gsLogoSrc: JsonInfo.gsLogoSrc||undefined,
							gsDetail: JsonInfo.gsDetail||undefined,
						};
					}
				}
			},
			delClass(row){

			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					zySf: undefined,
					jyXz: undefined,
					hyType: undefined,
					zyClass: undefined,
					shFwScope: undefined,
					gsGw: undefined,
					gsLogoSrc: undefined,
					gsDetail: undefined,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm(stemp) {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						_this.form.id = _this.basicId
						if (_this.form.id != undefined) {
							let formObj = {..._this.form};
							delete formObj.id
							addSupplierApprovalMx({
								classType:'com.srm.entity.SupplierInfo',
								classTypeIndex:'1',
								supplierInfoId:_this.basicId,
								jsonData:JSON.stringify(_this.form)
							}).then(response => {
								if (response.data.code === 0) {
									_this.bus.$emit('stepsFun', stemp);
								} else {
									_this.$fail(response.data.msg);
								}
							});
							// editSupplierInfo(_this.form).then(response => {
							// 	if (response.data.code === 0) {
							// 		_this.bus.$emit('stepsFun', 2);
							// 	} else {
							// 		_this.$fail(response.data.msg);
							// 	}
							// });
						}
					}
				});
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 0);
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.$success(res.msg);
					if (this.form.gsLogoSrc != "" && this.form.gsLogoSrc != undefined) {
						//如果修改附件 则删除原来的附件
						if (this.form.gsLogoSrc != res.data.url) {
							this.delFile(this.form.gsLogoSrc);
						}
					}
					this.form.gsLogoSrc = res.data.url;
					console.log(this.form)
				}
			},
			beforeAvatarUpload(file) {
				let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$fail('上传附件大小不能超过 2MB!');
				}
				if (!type == 'png')
					return isLt2M;
			},

		},
		watch:{
			classSel:function(val){
				console.log(val)
			}
		}
	};
</script>
<style scoped="scoped">

</style>
